import {HttpClient} from "./httpClient";
import {createContext} from "react";


export interface HttpClientContextType {
    client: HttpClient;
}

export const HttpClientContext = createContext<HttpClientContextType>(undefined as any);